module.exports = __webpack_public_path__ + "static/Sharing-94ec2ca605af12990795d2ed9e66ac03.png";